<template>
  <div class="ad-hoc-reports-picker">
    <Modal
      v-model="state"
      title="Select people to include in the report.."
      data-test="ad-hoc-report-picker-modal"
    >
      <div class="users-container scrollbar">
        <div v-for="user in data" :key="user.id" class="user">
          <button
            class="btn btn-default"
            @click="handleSelectedUser(user)"
            data-test="ad-hoc-report-picker-choice"
          >
            {{ user.firstName }} {{ user.lastName }}
          </button>
          <div v-if="selectedUsers.indexOf(user) !== -1">
            <img src="../../assets/button-icons/tick-icon-pink.svg" alt="selected user" />
          </div>
        </div>
      </div>
      <template #footer>
        <button
          @click="handleConfirm"
          class="btn btn-primary"
          :disabled="selectedUsers.length < 2"
          data-test="ad-hoc-report-picker-confirm-button"
        >
          Confirm
        </button>
        <button
          class="btn btn-default"
          @click="toggleState"
          data-test="ad-hoc-report-picker-cancel-button"
        >
          Cancel
        </button>
      </template>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { Modal } from "uiv";
import { ref, watch, watchEffect } from "vue";
import { useToggle } from "../../composables/useToggle";
import { useAxios } from "../../composables/api";
import { Analytics } from "../../services/analytics/analytics";
import { ShortUserDetailsApiModel } from "../../api-models";
import { csContext } from "../../services/cs-context";

const props = defineProps<{
  shown: boolean;
}>();

const emit = defineEmits(["select", "close"]);

const selectedUsers = ref<ShortUserDetailsApiModel[]>([]);

const { state, toggleState } = useToggle(false);

const { data } = useAxios<ShortUserDetailsApiModel[]>("/api/reportcreation/users-for-adhoc-groups");

const handleSelectedUser = (user: ShortUserDetailsApiModel): void => {
  const index = selectedUsers.value.indexOf(user);
  if (index === -1) selectedUsers.value.push(user);
  else {
    selectedUsers.value.splice(index, 1);
  }
};

const handleConfirm = (): void => {
  if (selectedUsers.value.length >= 2) {
    const name = "Ad Hoc Group";
    const userIds = selectedUsers.value.map((u) => u.id).join(",");
    const url = `/ad-hoc-group-report/${name}/${userIds}`;
    window.open(url, "_blank");
    emit("close");
  }
  // if (selectedComparison.value) {
  //   const url = `/SoloReport/Compare/${data.value?.first.reportType}/${props.reportEntityId}/${selectedComparison.value.reportType}/${selectedComparison.value.reportId}`;
  //   Analytics.actionAsync("Clicked Confirm Compare Reports", "CompareReports", {
  //     isReportOnSelf: props.isReportOnSelf,
  //     reportType: props.reportType,
  //     reportEntityId: props.reportEntityId,
  //     secondReportType: selectedComparison.value.reportType,
  //     secondReportEntityId: selectedComparison.value.reportId,
  //   }).then(() => {
  //     window.location.href = url;
  //   });
  // }
};

watchEffect(() => {
  state.value = props.shown;
});

watch(state, (newValue) => {
  if (!newValue) {
    emit("close");
  }

  const eventName = newValue
    ? "Clicked Open Ad Hoc Group Reports"
    : "Clicked Cancel Ad Hoc Group Reports";
  Analytics.action(eventName, "AdHocGroupReports", {
    includesSelf: !!selectedUsers.value.find((u) => u.id === csContext.user.id),
    numberOfUsers: selectedUsers.value.length,
  });
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";

.users-container {
  border-radius: 1rem;
  min-height: 10rem;
  max-height: 20rem;
  overflow-y: scroll;
  min-width: 90%;
  border: 1px solid @registration-background-color;
  padding: 2rem;
}

.user {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
}
</style>
